/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTenfourControl.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/tenfour-control";

export class AutogenModelTenfourControl<RowType extends ModelRow> extends Endpoint<RowType, RowTenfourControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTenfourControl extends ModelRow<RowTenfourControlFields> {
	constructor(values?: Partial<RowTenfourControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTenfourControlFields {
	address: string;
	company_id: string;
	customer_id: string;
	date_sent: Date;
	email_list: string;
	filename: string;
	id: string;
	is_active: string;
	is_ftp_active: string;
	is_sftp_active: string;
	passwd: string;
	port: number;
	proxy: string;
	remote_dir: string;
	remote_file: string;
	username: string;
}

